import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'audittrailclient';
  externalApplication = false;

  constructor(private route: ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      this.externalApplication = (params['ex'] == 'true');
    });
   }
}
